module.exports = __webpack_public_path__ + "static/media/xls.31f7f50c.svg";